import { configureStore } from '@reduxjs/toolkit';
import locationReducer from '../features/location/locationSlice';
import chatReducer from './chatSlice';
import notificationsReducer from './notificationsSlice';

export const store = configureStore({
  reducer: {
    location: locationReducer,
    chat: chatReducer,
    notifications: notificationsReducer,
  },
});

